import { TransferConstant } from './TransferConstant';
import AccountDetail from './steps/AccountDetail/AccountDetail';
import TransferAmount from './steps/TransferAmount/TransferAmount';
import ReviewTransfer from './steps/ReviewTransfer/ReviewTransfer';
import TransferNextSteps from './steps/TransferNextSteps/TransferNextSteps';

export const listSteps = [
  {
    id: '1',
    stepValues: 1,
    component: <AccountDetail />,
    label: TransferConstant.accountDeatilPage.label,
    stepperLabel: TransferConstant.accountDeatilPage.stepperLabel,
    showSecureLink: false,
    showBackLink: true,
    showWizard: true,
    card: {
      isActive: false,
    },
    faq: true,
    stepper: true,
  },
  {
    id: '2',
    stepValues: 2,
    component: <TransferAmount />,
    label: TransferConstant.transferAmountPage.label,
    stepperLabel: TransferConstant.transferAmountPage.label,
    showSecureLink: false,
    showBackLink: true,
    showWizard: true,
    card: {
      isActive: false,
    },
    faq: true,
    stepper: true,
  },
  {
    id: '3',
    stepValues: 3,
    component: <ReviewTransfer />,
    showBackLink: true,
    label: TransferConstant.transferReviewPage.label,
    stepperLabel: TransferConstant.transferReviewPage.label,
    showSecureLink: false,
    showWizard: false,
    faq: false,
    stepper: true,
    card: {
      isActive: true,
      title: 'Summary',
      fundingMethodType: 'External Asset Transfer',
      content:
        'The Transfer Request Form will be mailed to T. Rowe Price and submitted to the resigning financial institution on your behalf.',
      btnLabel: 'Generate my Transfer Form',
    },
  },
  {
    id: '4',
    stepValues: 4,
    component: <TransferNextSteps />,
    showBackLink: false,
    showSecureLink: false,
    showWizard: false,
    label: '',
    faq: false,
    stepper: false,
    card: {
      isActive: true,
      title: 'Need Help?',
      subTitle: 'Transfer Support',
      content:
        'Get help from a T. Rowe Price Transfer Specialist, available weekdays 8 a.m. - 8 p.m. ET.',
      btnLabel: 'Schedule a Call',
      footerTitle: '1-866-294-5526',
    },
  },
];
